<script lang="ts" setup>
  const route = useRoute();

  useHead({
    title: `Triple A - ${route.meta.title}`,
    meta: [{ name: 'og:title', content: `Triple A - ${route.meta.title}` }],
  });
</script>

<template>
  <div class="article-layout">
    <header class="article-layout__header">
      <div class="header__wrapper">
        <NuxtLink
          to="/"
          class="logo"
        >
          <img
            src="@/assets/images/nibe-logo.svg"
            width="80"
          />
        </NuxtLink>

        <NavigationUser />
      </div>
    </header>
    <div class="article-layout__content">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
  .article-layout {
    @apply h-screen min-h-screen bg-gray-50;

    .article-layout__header {
      @apply fixed top-0 left-0 z-10 flex h-[77px] w-full items-center justify-center border-b border-b-gray-300 border-opacity-80 bg-white shadow-sm;

      .header__wrapper {
        @apply flex w-full max-w-container-xxl justify-between p-2 px-6;
      }
    }

    .article-layout__content {
      @apply pt-[77px] p-2 ;
      height: calc (100vh - 77px);
      min-height: calc (100vh - 77px);
    }
  }
</style>
